import ContextMenu from "pages/_components/ContextMenu";
import TransactionTicket from "pages/_components/TransactionTicket";
import CesionEcheqTransactionData from "pages/checks/Echeqs/EcheqTransactions/CesionEcheqTransactionData";
import ModifyPendingTransactionModal from "pages/transactions/_components/ModifyPendingTransactionModal";
import { bool, func, shape, string } from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { selectors } from "reducers/checks";
import { actions as formActions } from "reducers/form";
import { selectors as statusSelectors } from "reducers/status";
import { echeqConceptLabel } from "util/checks";
import * as i18n from "util/i18n";
import { exportGenericTicketPdfWithSuccessMessage, getGeneralTicketItem } from "util/transaction";
import { resolveEmbeddedV3GoBackPath } from "util/v3ShellLayoutSync";
import { CURRENCY_CODE_COELSA } from "../../../../constants";

const FORM_ID = "echeq.transaction";

class CesionEcheqTransaction extends Component {
    static propTypes = {
        transactionData: shape({}).isRequired,
        dispatch: func.isRequired,
        isDesktop: bool.isRequired,
        isSmallDesktop: bool.isRequired,
        fetching: bool.isRequired,
        embeddedInV3Shell: bool,
        lastHrefPathname: string,
    };

    static defaultProps = {
        embeddedInV3Shell: false,
        lastHrefPathname: "",
    };

    state = {
        isModalDisplayed: false,
        showDrawerMobile: false,
        fetchingDownload: false,
    };

    componentDidMount() {
        const { dispatch, transactionData } = this.props;
        if (!transactionData.idTransaction && localStorage.getItem("flow")) {
            dispatch(push(`${JSON.parse(localStorage.getItem("flow"))}`));
        }
    }

    centerContentMobile = () => (
        <div className="title-account-header-multiline-background-blue">
            <h1 style={{ width: "100%", marginTop: "2px" }}>{i18n.get(`echeqs.emit-cesion.title`)}</h1>
        </div>
    );

    getTicketGoBackPath = () => {
        const { lastHrefPathname } = this.props;
        return resolveEmbeddedV3GoBackPath("/echeqs", lastHrefPathname);
    };

    handleBack = () => {
        const { dispatch } = this.props;
        dispatch(push(this.getTicketGoBackPath()));
    };

    summaryDataComponent = () => <CesionEcheqTransactionData />;

    signTransaction = () => {
        const { dispatch, transactionData } = this.props;

        const signTransactionData = this.summaryDataComponent();

        dispatch(push("/transactions/sign"));
        dispatch(
            formActions.signTransactionData({
                idTransaction: transactionData?.idTransaction,
                idActivity: transactionData.idActivity,
                idForm: "",
                content: signTransactionData,
                title: "echeqs.transaction.cesion.label",
                pendingDispatch: transactionData?.pendingDispatch,
            }),
        );

        dispatch(
            formActions.signTransactionPreview({
                idActivity: transactionData.idActivity,
                idTransaction: transactionData.idTransaction,
                idForm: "",
                ticketData: transactionData,
            }),
        );
    };

    rightContentTransactionScheme = () => {
        const { isDesktop, transactionData } = this.props;

        if (transactionData.idTransactionStatus === "FINISHED") {
            return (
                <ContextMenu
                    isDesktop={isDesktop}
                    color={!isDesktop ? "white" : undefined}
                    buttonClassName="align-self-center account-dropdown-header-font font-black-alpha ml-2"
                    items={[
                        {
                            label: "global.download",
                            onClick: this.exportPdf,
                        },
                    ]}
                />
            );
        }
        return (
            <ContextMenu
                isDesktop={isDesktop}
                color={!isDesktop ? "white" : undefined}
                buttonClassName="align-self-center account-dropdown-header-font font-black-alpha ml-2"
                items={[
                    {
                        label: "pendingTransaction.info.scheme",
                        onClick: () => this.setState({ showDrawerMobile: true }),
                    },
                ]}
            />
        );
    };

    exportPdf = async () => {
        this.setState({ fetchingDownload: true });

        const { transactionData, dispatch } = this.props;
        const { echeq } = transactionData;

        const concept = `${echeq.cheque_concepto} ${echeqConceptLabel(echeq.cheque_concepto, "-")}`;

        const ticketData = {
            ticketName: i18n.get("echeqs.emit-cesion.title"),
            ticketBody: [
                getGeneralTicketItem(`${FORM_ID}.date.time`, transactionData?.submitDateTime, "datetime"),
                getGeneralTicketItem(
                    `${FORM_ID}.transaction`,
                    transactionData.idTransaction.substring(0, 8).toUpperCase(),
                    "string",
                ),
                getGeneralTicketItem(`${FORM_ID}.echeq.number`, echeq.cheque_numero, "string"),
                getGeneralTicketItem(`${FORM_ID}.echeq.id`, echeq.cheque_id, "string"),
                getGeneralTicketItem(
                    `${FORM_ID}.cesion_date`,
                    transactionData?.cesion?.fecha_emision_cesion,
                    "string",
                ),
                getGeneralTicketItem(`${FORM_ID}.cesion.id`, transactionData?.cesion?.cesion_id, "string"),
                getGeneralTicketItem(`${FORM_ID}.beneficiary`, transactionData.beneficiary.reference, "string"),
                getGeneralTicketItem(`${FORM_ID}.beneficiary.document`, transactionData.beneficiary.document, "string"),
                getGeneralTicketItem(`${FORM_ID}.cesion.address`, transactionData?.address, "string"),
                getGeneralTicketItem(
                    `${FORM_ID}.amount`,
                    echeq.monto,
                    echeq?.moneda === CURRENCY_CODE_COELSA.USD ? "amountUSD" : "amountARS",
                ),
                getGeneralTicketItem(`${FORM_ID}.emision`, echeq?.fecha_emision, "datetime"),
                getGeneralTicketItem(`${FORM_ID}.payed`, echeq?.fecha_emision, "datetime"),
                getGeneralTicketItem(
                    `${FORM_ID}.echeq.type`,
                    i18n.get(`echeqs.emit.${echeq?.cheque_tipo?.toLowerCase()}.label`),
                    "string",
                ),
                getGeneralTicketItem(`${FORM_ID}.echeq.character`, echeq?.cheque_caracter, "string"),
                getGeneralTicketItem(`${FORM_ID}.mode`, i18n.get(`echeqs.${echeq.cheque_modo}.modo`), "string"),
                getGeneralTicketItem(`${FORM_ID}.concept`, concept, "string"),
                getGeneralTicketItem(`${FORM_ID}.motive`, echeq.cheque_motivo_pago, "string"),
                getGeneralTicketItem(`${FORM_ID}.reference`, transactionData.reference || "", "string"),
                getGeneralTicketItem(`${FORM_ID}.value.reference`, transactionData.referencevalue || "", "string"),
                getGeneralTicketItem(`${FORM_ID}.coelsa.response`, transactionData.coelsaResponse, "string"),
                getGeneralTicketItem(`${FORM_ID}.coelsa.code`, transactionData.coelsaCode, "string"),
            ],
        };

        await exportGenericTicketPdfWithSuccessMessage(ticketData, dispatch, i18n.get("global.download.success"));

        this.setState({ fetchingDownload: false });
    };

    buttonsDetail = () => {
        const { dispatch, transactionData } = this.props;

        if (transactionData) {
            const { idTransactionStatus } = transactionData;
            if (idTransactionStatus !== "PENDING") {
                return [
                    {
                        label: "global.goToHome",
                        bsStyle: "primary",
                        onClick: () => dispatch(push("/desktop")),
                    },
                ];
            }
        }
        return [
            {
                label: "global.modify",
                bsStyle: "outline",
                onClick: () => this.setState({ isModalDisplayed: true }),
            },
        ];
    };

    render() {
        const { transactionData, isDesktop, dispatch, isSmallDesktop, fetching, embeddedInV3Shell } = this.props;
        const { isModalDisplayed, showDrawerMobile, fetchingDownload } = this.state;

        return (
            <>
                {transactionData?.idTransaction && (
                    <TransactionTicket
                        embeddedInV3Shell={embeddedInV3Shell}
                        embeddedV3GoBackPath="/echeqs"
                        embeddedV3LayoutScopes={["echeqs", "echeqsPending"]}
                        notificationScope="echeqs"
                        handleClick={this.exportPdf}
                        handleClickMessage="global.download"
                        uniqueDownload={transactionData?.idTransactionStatus === "FINISHED"}
                        rightContent={
                            transactionData?.idTransactionStatus === "PENDING" && this.rightContentTransactionScheme
                        }
                        emptyRightOption={
                            (isDesktop && transactionData?.idTransactionStatus !== "FINISHED") ||
                            (!isDesktop &&
                                transactionData?.idTransactionStatus !== "PENDING" &&
                                transactionData?.idTransactionStatus !== "FINISHED")
                        }
                        downloadImageWhite={!isDesktop}
                        fetching={fetching}
                        headerClassName={!isDesktop ? "blue-main-header-mobile blue-main-title-mobile" : ""}
                        centerElement={isDesktop ? undefined : this.centerContentMobile}
                        hasInlineButtons
                        hideMobileMenu={!isDesktop}
                        handleBack={this.handleBack}
                        summary={transactionData}
                        buttonsDetail={this.buttonsDetail()}
                        isDesktop={isDesktop}
                        isSmallDesktop={isSmallDesktop}
                        showDrawerMobile={showDrawerMobile}
                        closeMobileDrawer={() => this.setState({ showDrawerMobile: false })}
                        onSignTicket={this.signTransaction}
                        ignoreHomeButton
                        summaryTitle="echeqs.emit-cesion.title"
                        isFetchingExport={fetchingDownload}>
                        <ModifyPendingTransactionModal
                            isDesktop={isDesktop}
                            isDisplayed={isModalDisplayed}
                            handleDismiss={this.handleDismiss}
                            dispatch={dispatch}
                            idTransaction={transactionData.idTransaction}
                        />
                        <CesionEcheqTransactionData isDesktop={isDesktop} />
                    </TransactionTicket>
                )}
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    transactionData: selectors.getTransactionEcheqData(state),
    fetching: selectors.getFetching(state),
    lastHrefPathname: statusSelectors.getPathname(state),
});

export default connect(mapStateToProps)(CesionEcheqTransaction);
